import "core-js/stable";
import "regenerator-runtime/runtime";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "moment/locale/fr";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import "./public/css/main.scss";
import initialize from "config";
import { store } from "store";
import App from "./app";
import moment from "moment";

// Initialization of all external libraries
initialize();

moment.updateLocale("en", {
	week: {
		dow: 1 // Monday is the first day of the week.
	}
});

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: true,
			refetchOnMount: true,
			staleTime: 0,
			cacheTime: 0,
			retry: 1
		}
	}
});

const Toast = () => {
	return (
		<QueryClientProvider client={queryClient}>
			<ReactQueryDevtools />
			<Provider store={store}>
				<App />
			</Provider>
		</QueryClientProvider>
	);
};

ReactDOM.render(<Toast />, document.getElementById("main"));
